import { useStytchMember } from "@stytch/react/b2b";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isDev() {
  return import.meta.env.VITE_ENV === "development";
}

export const useIsPrivilegedUser = () => {
  const { member } = useStytchMember();
  return member && ["jamiejicuffe@gmail.com"].includes(member.email_address);
};
